/* eslint @typescript-eslint/no-var-requires: 0 */

export const commonEnvironment = {
  // eslint-disable-next-line @nx/enforce-module-boundaries
  version: require('../../../../package.json').version,
  appKeyword: 'teachers-dashboard'
};
